import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core'
import { APIService } from '../services/api.service'
import { Response, } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class AuthenticationService {

    readonly sessionCleared$ = new Subject<void>();

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        })
    }
    constructor(private _http: HttpClient, private router: Router,private _apiServices: APIService) {

    }

    login(username, password) {

        let data = { "username": username, "password": password , statusCheck: true}
        console.log('data')
        console.log(data)
        return this._http.post(environment.apiURL + "/auth/adminLogin", data, this.httpOptions)
            .catch(this.handleError);
    }
    partnerLogin(username, password) {
        let data = { "username": username, "password": password }
        return this._http.post(environment.apiURL + "/auth/partnerLogin", data, this.httpOptions)
            .catch(this.handleError);
    }

    // stored session if its token exists and has not expired, otherwise null
    getActiveSession(): any {
        let user;
        try {
            user = JSON.parse(localStorage.getItem('currentUser'));
        } catch (e) {
            return null;
        }
        if (!user || !user.token) {
            return null;
        }
        try {
            const payload = JSON.parse(atob(user.token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
            if (payload.exp && payload.exp * 1000 <= Date.now()) {
                return null;
            }
        } catch (e) {
            return null;
        }
        return user;
    }

    clearSession() {
        ['currentUser', 'loggingStatus', 'isPageEditable', 'userMenuacessbilityList', 'userMenuCache']
            .forEach(key => localStorage.removeItem(key));
        this.sessionCleared$.next();
    }

    logOut() {
        let user;
        try {
            user = JSON.parse(localStorage.getItem('currentUser'));
        } catch (e) { }
        const isPartner = user && user.userDetail && user.userDetail.partnerId;
        this.clearSession();
        this.router.navigate([isPartner ? 'partnerLogin' : 'login']);
    }

    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts